var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"job-category-icon",class:_setup.sizeClass},[_c('img',{attrs:{"src":_setup.src,"alt":"","width":"16","height":"16"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }